module.exports = __webpack_public_path__ + "img/minvody-excursions.1ddf75c5.jpg";